import React from 'react';
import './index.css';
import { AngleDownCircle } from '../Icons';

export interface DropdownMenuProps {
    children: React.ReactNode;
    label: string
}

const DropdownMenu: React.FC<DropdownMenuProps> = ({children, label}) => {

    const [isOpen, setIsOpen] = React.useState(false);
    
    const toggleDropdown = () => {
        setIsOpen(!isOpen);
    };

    return (
        <div className={`dropdown-menu ${isOpen ? 'open' : ''}`}>
            <div className='dropdown-menu-header'>
              <button className={`dropdown-menu-btn ${isOpen ? 'open' : ''}`} onClick={toggleDropdown}>
                <AngleDownCircle/>
              </button>
              <span className='dropdown-menu-title'>
                <p>
                  {label}
                </p>
              </span>
            </div>
            {true && <div className={`dropdown-children ${isOpen ? 'open': ''}`}>{children}</div>}
        </div>
    );
};

export default DropdownMenu;